import { initBrowserRum as _initBrowserRum } from '@smg-real-estate/browser-rum';

export const initBrowserRum = (): void => {
  _initBrowserRum({
    applicationId: import.meta.env.VUE_APP_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VUE_APP_DATADOG_CLIENT_TOKEN,
    service: 'unified-business-manager',
    env: import.meta.env.VUE_APP_STAGE,
    sessionSampleRate: 100,
    // TODO: allowedTracingUrls: [import.meta.env.VUE_APP_INSERTION_FUNNEL_API_BASE_URL],
    version: import.meta.env.VUE_GITHUB_SHA,
  });
};
